import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import type { ImportantNoticePolicyDetails } from '@shared/types/hotel-content';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './ImportantNoticePolicy.module.scss';

import useTranslation from '@hotels-hotel-detail/data-access/stores/useTranslation';
import TranslationButton from '@shared/ui/components/Translation/TranslationButton';
import TranslationContent from '@shared/ui/components/Translation/TranslationContent';
import { withI18n } from '@shared/ui/contexts/i18n';
import { TranslationState } from '@shared/utils-frontend/translate-state';

type Props = {
  policy: ImportantNoticePolicyDetails;
  i18n: I18nService;
};

const ImportantNoticePolicy = ({ i18n, policy }: Props) => {
  const { content, locale, translated } = policy;

  const {
    isPending,
    state: translationState,
    translate,
    translatedData,
  } = useTranslation({
    contentType: 'hotel-policy',
    sourceLocale: locale,
    targetLocale: i18n.culture.locale,
    data: { content },
    excludedFields: ['hotel-policy'],
  });

  return (
    <TranslationContent isPending={isPending}>
      <BpkText
        textStyle={TEXT_STYLES.bodyDefault}
        className={STYLES.ImportantNoticePolicy}
      >
        {translationState === TranslationState.TRANSLATED
          ? translatedData?.content
          : policy.content}
      </BpkText>
      {!translated && (
        <div className={STYLES.ImportantNoticePolicy__translateButton}>
          <TranslationButton
            onTranslate={translate}
            translationState={translationState}
          />
        </div>
      )}
    </TranslationContent>
  );
};

export default withI18n(ImportantNoticePolicy);
